import Vue from "vue";
import Vuex from "vuex";
import moment from 'moment'

Vue.use(Vuex);

import axios from "axios";

const state = Vue.observable(
    { // = data
        sessionId: '',
        locationId: '',
        customerId: '',
        menuId: '',
        menus: [],
        items: [],
        cart: [],
        user: null,
        store: {},
        userInfo: {
            name: null,
            phone: null,
            sms: true,
            action: 'pickup'
        },
        tip_amount: 0,
        tipRules: {},
        ablyKey: '',
        tax: 0,
        timeZone: "America/New_York",
        close: "false",
        square: null,
        orderResult: {},
        customerLogging: false,
        stripeClientSecret:null,
        orderPendingId:null
    }
);
{
    let locationIdFromPath = null;
    try {
        let paths = window.location.pathname.split("/")
        for (var i = paths.length - 1; i >= 0; i--) {
            if (paths[i]) {
                locationIdFromPath = paths[i]
                break
            }
        }
        //			locationIdFromPath =  window.location.hostname.substring(0,window.location.hostname.indexOf('.'));
    } catch (e) {
        console.log("Error_location_id", e)
    }
    Vue.prototype.$locationIdFromPath = locationIdFromPath
}
let USER_ID = Vue.prototype.$locationIdFromPath + "_" + "userId"
let USER_INFO = Vue.prototype.$locationIdFromPath + "_" + "userInfo"
let CART_DETAILS = Vue.prototype.$locationIdFromPath + "_" + "cartDetails"
let ORDER_STATE = Vue.prototype.$locationIdFromPath + "_" + "orderState"
let ORDER_STATE_UPDATE_TIME = Vue.prototype.$locationIdFromPath + "_" + "orderUpdateTime"
let PAID_ORDER_DATA = Vue.prototype.$locationIdFromPath + "_" + "orderData"
let SESSION_ID = Vue.prototype.$locationIdFromPath + "_" + "sessionId"

const OS_ORDERING = "ordering"
const OS_CHECKOUT = "checkout"
const OS_PAID = "paid"

const CART_ORDER_TIME_LIMIT_MINUTS = 20;

var oldCart = localStorage.getItem(CART_DETAILS);

export default new Vuex.Store({
    state,
    getters: {
        get7Days() {
            return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
        },
        getUserInfo(state) {
            return state.userInfo.name === null ? localStorage.getItem(USER_INFO) : state.userInfo
        },
        getRouteFromLocalStorage(state) {
            var route = ""

            let os = localStorage.getItem(ORDER_STATE);
            let lastmodified = localStorage.getItem(ORDER_STATE_UPDATE_TIME);
            let od = localStorage.getItem(PAID_ORDER_DATA);

            if (os === OS_PAID) {
                // 5) & 6)
                route = "Order Result"
                state.orderResult = JSON.parse(od)
            }

            if (os === OS_CHECKOUT) {
                route = "Checkout"
                oldCart = localStorage.getItem(CART_DETAILS);
                //set login  
            }

            if (os === OS_ORDERING) {
                route = "Home"
                if (moment().diff(moment(lastmodified), 'minutes') > CART_ORDER_TIME_LIMIT_MINUTS) {
                    state.orderResult = {}
                    localStorage.removeItem(ORDER_STATE)
                    localStorage.removeItem(ORDER_STATE_UPDATE_TIME)
                    localStorage.removeItem(PAID_ORDER_DATA)
                    localStorage.removeItem(CART_DETAILS)
                    localStorage.removeItem(USER_ID)
                    oldCart = []
                }
                //                else{
                //                    Auto Login code at App.Vue
                //                }
            }

            return route;
        },
        getState(state) {
            return state
        },
        menu_and_items(state) {
            return state.menus
        },

        cartItems(state) {
            state.cart = state.cart.filter(cartItem => {
                let item = state.items.find(item => item._id == cartItem.item_id);
                let shouldKeep = !(item === null || item === undefined)
                return shouldKeep;
            });
            return state.cart.map(cartItem => {
                const item = state.items.find(item => item._id == cartItem.item_id);
                let selected_option_names = [];
                let size = [];

                cartItem.selected_options.forEach(selected_option => {
                    selected_option.options.forEach(option => {
                        //console.log("Option", selected_option.size[option])
                        size.push(selected_option.size[option])
                        selected_option_names.push(item.optionGroups[selected_option.option_group].options[option].title);
                    })
                })

                return {
                    item: item,
                    selected_options: cartItem.selected_options,
                    selected_option_names: selected_option_names,
                    size: size,
                    quantity: cartItem.quantity,
                    special_note: cartItem.special_note,
                    total_price: cartItem.total_price
                };
            })
        },

        cartTotal(state) {
            var sum = 0;
            var qty = 0;

            state.cart.forEach(item => {
                sum += item.total_price;
                qty += item.quantity;
            })

            return { sum: sum, qty: qty };
        },
        getTipRules(state) {
            return state.tipRules
        },
        orders(state) {
            // axios call to server and get orders from server
            return state.orderResult;
        },
        tipAmount(state) {
            return state.tip_amount
        },
        getCurrentTime(state) {
            let tz = (state.timeZone).trim();
            let tzTime = moment().tz(tz);
            let workingDay = tzTime
            //state.close
            let closeTimeWithoutTZ = moment(state.close, ["h:mma", "hh:mma", "h:mmA", "hh:mmA", "h:mm a", "hh:mm a", "h:mm A", "hh:mm A"])
            if (closeTimeWithoutTZ.isValid()) {
                let closeTimeTZ = moment().tz(tz).set({ H: closeTimeWithoutTZ.hours(), m: closeTimeWithoutTZ.minutes(), s: 0 })
                if (tzTime.isBefore(closeTimeTZ)) {
                    workingDay = tzTime.subtract(1, 'days')//it will change in UTC
                }
            }
            //console.log(workingDay, workingDay.format())
            return workingDay
        },
        getCart(state, getters) {
            const subTotal = Math.round(getters.cartTotal.sum)
            const tax = Math.round((subTotal * state.tax) / 100.0)
            const tax2 = Math.round((subTotal * state.tax2) / 100.0)
            const tip = Math.round(state.tip_amount * 100.0)
            const params = {
                location: state.locationId,
                customer: state.customerId,
                menu: state.menuId,
                orderTime: moment().format(),
                subTotal: subTotal,
                tax: tax,
                tax2: tax2,
                tip: tip,
                total: subTotal + tax + tax2 + tip,
                items: [],
                clientOrderId: Math.random().toString(36),  // TODO its for developement 
                debugTransaction:false // TODO its for developement
            }
            state.cart.forEach(cartItem => {
                const item = state.items.find(item => item._id == cartItem.item_id);
                let options = [];
                cartItem.selected_options.forEach(selected_option => {
                    selected_option.options.forEach(option => {
                        const cur_option = item.optionGroups[selected_option.option_group].options[option]
                        cur_option["count"] = selected_option.size[option]
                        options.push({
                            ...cur_option
                        });
                    })
                })
                params.items.push({
                    _id: item._id,
                    title: item.title,
                    price: item.price,
                    specialNote: cartItem.special_note,
                    quantity: cartItem.quantity,
                    options: options
                })
            })
            return params;
        }
    },
    mutations: {
        pushItemToCart(state, cartItem) {
            state.cart.push(cartItem);
        },

        cartUpdate(state, obj) {
            obj.cart.total_price = obj.data.total_price;
            obj.cart.quantity = obj.data.quantity;
            obj.cart.special_note = obj.data.special_note;
            obj.cart.selected_options = obj.data.selected_options;
        },
        cart_delete_index(state, index) {
            state.cart.splice(index, 1);
        },
        SET_CART_LC(state) {
            localStorage.setItem(CART_DETAILS, JSON.stringify(state.cart))
            localStorage.setItem(ORDER_STATE_UPDATE_TIME, moment().format())
            if (state.cart.length == 0) {
                localStorage.setItem(ORDER_STATE, OS_ORDERING)
            }
        },
        SET_STORE_DATA(state, data) {
            {
                data.store.longitude = data.longitude
                data.store.latitude = data.latitude
                data.store.phone = data.phone
                data.store.zipCode = data.zipCode
                data.store.hours = data.hours
                data.store.homeUrl = data.homeUrl
                data.store.pauseOrders = data.pauseOrders                
                state.store = data.store

                state.square = data.square
                state.stripe = data.stripe
                state.paymentSystem = data.paymentSystem || "square"

                state.customerLogging = data.customerLogging
            }
            state.menuId = data.menu._id
            {
                //              Filter Items and Options which is unavailable in list86
                let list86 = data.list86
                state.menus = data.menu.sections.filter(section => {

                    section.items = section.items.filter(item => {
                        var availableItem = true
                        list86.forEach(item86 => {
                            //                          console.log(item86.name)
                            if (item86.isItem && (item86.name.trim().toLowerCase() === item.title.trim().toLowerCase())) {
                                if (item86.unavailable) {
                                    if (item86.unavailableForDay === null) {
                                        availableItem = false
                                    } else {
                                        let unavailableDate = moment.utc(item86.unavailableForDay, "YYYY-MM-DD").format("YYYY-MM-DD")
                                        let cutOffDate = data.getCurrentTime.format("YYYY-MM-DD")
                                        availableItem = !(cutOffDate === unavailableDate)// false means unavilable for same date
                                    }
                                }
                            }
                        })

                        //  console.log(item.title, availableItem)                       
                        if (availableItem) {

                            item.optionGroups = item.optionGroups.filter(optionGroup => {
                                optionGroup.options = optionGroup.options.filter(option => {
                                    var availableOption = true
                                    list86.forEach(option86 => {
                                        if (!option86.isItem && (option86.name.trim().toLowerCase() === option.title.trim().toLowerCase())) {
                                            if (option86.unavailable) {
                                                if (option86.unavailableForDay === null) {
                                                    availableOption = false
                                                } else {
                                                    let unavailableDate = moment.utc(option86.unavailableForDay, "YYYY-MM-DD").format("YYYY-MM-DD")
                                                    let cutOffDate = data.getCurrentTime.format("YYYY-MM-DD")
                                                    availableOption = !(cutOffDate === unavailableDate)// false means unavilable for same date
                                                }
                                            }
                                        }
                                    })

                                    return !option.trackable ? true : availableOption
                                })
                                //                                implement min and max new when option will minus
                                let choiceMin = optionGroup.choiceMin
                                //                                let choiceMax = optionGroup.choiceMax                                
                                if (optionGroup.options.length > 0
                                    && choiceMin > 0
                                    && optionGroup.options.length < choiceMin) {
                                    optionGroup.choiceMin = 1
                                }
                                return optionGroup.options.length > 0
                            })
                        }

                        return availableItem
                    })

                    return section.items.length > 0
                })

                if (data.macros !== undefined) {
                    var mE = /{{([^}]+)}}/g;
                    var marcos = data.macros.split("\n")
                    state.menus.forEach(menu => {
                        menu.items.forEach(item => {
                            {
                                var str = item.title.slice()
                                var matchMacro = str.match(mE)
                                if (matchMacro && matchMacro.length > 0) {
                                    let match;
                                    while ((match = mE.exec(str)) !== null) {
                                        var start = match.index
                                        var end = mE.lastIndex
                                        var subString = str.substring(start, end)

                                        let macroKey = "";
                                        let defaultValue = subString;
                                        if (subString.indexOf(",") >= 0) {
                                            macroKey = subString.slice().replace("{{", "").replace("}}", "").split(",")[0]
                                            defaultValue = subString.slice().replace("{{", "").replace("}}", "").split(",")[1]
                                        }else{
                                            macroKey = subString.slice().replace("{{", "").replace("}}", "");
                                        }

                                        let newValue = ""
                                        let hasMacroValue = marcos.some(macro => {
                                            if (macro.indexOf("=") >= 0) {
                                                newValue = macro.split("=")[1]
                                                return macro.split("=")[0].toLowerCase().trim() === macroKey.toLowerCase().trim()
                                            }
                                            return false
                                        })
                                        item.title = item.title.replace(subString, hasMacroValue ? newValue : defaultValue)                                        
                                    }
                                }
                            }
                            item.optionGroups.forEach(og => {
                                og.options.forEach(option => {
                                    {
                                        var str = option.title.slice()
                                        var matchMacro = str.match(mE)
                                        if (matchMacro && matchMacro.length > 0) {
                                            let match;
                                            while ((match = mE.exec(str)) !== null) {
                                                var start = match.index
                                                var end = mE.lastIndex
                                                var subString = str.substring(start, end)

                                                let macroKey = "";
                                                let defaultValue = subString;
                                                if (subString.indexOf(",") >= 0) {
                                                    macroKey = subString.slice().replace("{{", "").replace("}}", "").split(",")[0]
                                                    defaultValue = subString.slice().replace("{{", "").replace("}}", "").split(",")[1]
                                                }else{
                                                    macroKey = subString.slice().replace("{{", "").replace("}}", "");
                                                }

                                                let newValue = ""
                                                let hasMacroValue = marcos.some(macro => {
                                                    if (macro.indexOf("=") >= 0) {
                                                        newValue = macro.split("=")[1]
                                                        return macro.split("=")[0].toLowerCase().trim() === macroKey.toLowerCase().trim()
                                                    }
                                                    return false
                                                })
                                                option.title = option.title.replace(subString, hasMacroValue ? newValue : defaultValue)
                                            }
                                        }
                                    }
                                })
                            })
                        })
                    })
                }

                state.items = []
                state.menus.forEach(section => {
                    section.items.forEach(item => {
                        state.items.push(item)
                    })
                })

            }
            // state.items = data.items
            // state.fullfillment = data.fullfillment
            {
                state.tipRules = data.tipRules
                state.ablyKey = data.ablyKey
                state.tax = data.tax ? data.tax / 100.0 : 0
                state.tax2 = data.tax2 ? data.tax2 / 100.0 : 0
                state.taxName1 = data.taxName1 ? data.taxName1 : "Tax1"
                state.taxName2 = data.taxName2 ? data.taxName2 : "Tax2"
                state.timeZone = data.timeZone ? data.timeZone : "America/New_York"
                state.close = data.close
            }
        },
        SET_USER_INFO(state, data) {
            state.customerId = data._id
            state.userInfo.name = data.name
            state.userInfo.phone = data.phone
            state.sessionId = Date.now()

            localStorage.setItem(USER_ID, data._id)
            localStorage.setItem(USER_INFO, JSON.stringify(state.userInfo))
            localStorage.setItem(SESSION_ID, state.sessionId)
        },
        SET_TIP(state, data) {
            state.tip_amount = data
        },
        SET_LOCATION_ID(state, data) {
            state.locationId = data
        },
        SET_ORDER_RESULT(state, data) {
            state.orderResult = data
        }        
    },
    actions: { // = methods           
        new_order({ state }) {
            state.stripeClientSecret = null
            state.orderPendingId = null 
            state.customerId = ''
            state.userInfo.name = null
            state.userInfo.phone = null
            state.orderResult = {}
            state.tip_amount = 0
            localStorage.removeItem(USER_ID)
            localStorage.removeItem(ORDER_STATE)
            localStorage.removeItem(ORDER_STATE_UPDATE_TIME)
            localStorage.removeItem(PAID_ORDER_DATA)
            localStorage.removeItem(CART_DETAILS)
            oldCart = []
            state.cart = []
        },
        setPendingOrder({state}, {stripeClientSecret, orderPendingId}){
            state.stripeClientSecret = stripeClientSecret
            state.orderPendingId = orderPendingId
        },
        clearPendingOrder({state}){
            state.stripeClientSecret = null
            state.orderPendingId = null
        },
        /**
         * fetch the products
         * 
         */
        fetch_products() {
            // make a call

            // call the mutation
        },

        /**
         * 
         * @param {*} context 
         * @param {*} cartItem 
         */
        addItemToCart(context, cartItem) {
            context.commit('pushItemToCart', cartItem);
            context.commit('SET_CART_LC');
        },

        /**
         * 
         */
        updateCart(context, obj) {
            const cart = context.state.cart.find((item, index) => index === obj.cart_index);
            //console.log(obj.data);

            if (cart) {
                context.commit('cartUpdate', {
                    cart: cart,
                    data: obj.data
                });
            }
            context.commit('SET_CART_LC');
        },

        /**
         * 
         * 
         */
        deleteCartItem(context, index) {
            context.commit('cart_delete_index', index);
            context.commit('SET_CART_LC');
        },

        /**
         * initialize store data
         */
        async initStore({ commit, getters }, id) {
            commit('SET_LOCATION_ID', id)
            let url = `/info/${id}`

            try {
                const response = await axios({ url: url, method: 'GET' })

                if (response.status === 200) {
                    {
                        let data = response.data
                        data["getCurrentTime"] = getters.getCurrentTime
                        commit('SET_STORE_DATA', data)
                    }
                    document.title = response.data.store.title
                    if (state.items.length > 0) {
                        try {
                            state.cart = oldCart !== null ? JSON.parse(oldCart) : []
                        } catch (E) {
                            console.log(E);
                        }
                    }
                    return { status: 'success' }
                } else {
                    return { status: 'error' }
                }
            } catch {
                return { status: 'error' }
            }
        },
        ifLogin({ state }) {
            let customerId = localStorage.getItem(USER_ID)
            if (customerId !== null && customerId !== undefined) {
                state.customerId = customerId
                state.userInfo = JSON.parse(localStorage.getItem(USER_INFO))
                state.sessionId = localStorage.getItem(SESSION_ID)
            }
        },
        saveUserInfo({ commit, state }, payload) {
            const url = `/login/${state.locationId}`
            const params = {
                name: payload.name,
                phone: payload.phone
            }
            return new Promise((resolve, reject) => {
                axios({ url: url, data: params, method: 'POST' })
                    .then(response => {
                        commit('SET_USER_INFO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        setOrderPrepare({ getters }) {
            const url = `/orderPrepare`
            let params = getters.getCart;
            return axios({ url: url, data: params, method: 'POST' })
        },
        setOrderUpdate({ state, getters }) {
            const url = `/orderUpdate/${state.orderPendingId}`
            let params = getters.getCart;
            return axios({ url: url, data: params, method: 'POST' })
        },
        setOrderComplete({ state },orderPendingId) {
            console.log(state)
            const url = `/orderComplete/${orderPendingId}`
            return axios({ url: url, method: 'POST' })
        },

        setOrderChekout({ getters }) {            
            const url = `/orderCheckout`
            let params = getters.getCart;
            return axios({ url: url, data: params, method: 'POST' })
        },

        submitPayment({ commit, state, getters }, payload) {
            return new Promise((resolve, reject) => {
                        const url = `/order/${state.locationId}`
                        let params = getters.getCart;
                        params["nonce"] = payload.nonce;
                        params["cardObject"] = payload.cardData;
                        params.debugTransaction = true
                        
                        axios({ url: url, data: params, method: 'POST' })
                            .then(response => {
                                if (response.status === 200 && response.data.success) {
                                    commit('SET_ORDER_RESULT', response.data)
                                    localStorage.setItem(ORDER_STATE, OS_PAID)
                                    localStorage.setItem(PAID_ORDER_DATA, JSON.stringify(response.data))
                                    localStorage.setItem(ORDER_STATE_UPDATE_TIME, moment().format())
                                    resolve({
                                        status: 'success',
                                        res: response.data
                                    })
                                } else {
                                    resolve({
                                        status: 'error',
                                        res: response.data.error
                                    })
                                }
                            })
                            .catch(error => {
                                reject(error)
                            })
            })
        },
        ifOrderStatus({ dispatch, state }) {
            //check if paid and login, 
            let os = localStorage.getItem(ORDER_STATE)
            return new Promise((resolve) => {
                if (os === null || os === undefined) {
                    dispatch('new_order')
                    resolve()
                } else if (os === OS_PAID && state.userInfo.name !== null) {
                    let od = JSON.parse(localStorage.getItem(PAID_ORDER_DATA));
                    dispatch('orderStatus', od)
                        .then(r => {
                            let status = r.status
                            if (status === "Done" || status === "Cancelled" || status === "Rejected") {
                                dispatch('new_order')
                                resolve()
                            }
                        })
                }
            })
        },
        orderStatus({ context }, payload) {
            console.log(context)
            return new Promise((resolve, reject) => {
                const url = `/orderStatus/` + payload._id
                axios({ url: url, method: 'GET' })
                    .then(r => {
                        resolve(r.data)
                    })
                    .catch(e => {
                        reject(e)
                    })
            })
        },

        customerCancel({ context }, payload) {
            console.log(context)
            return new Promise((resolve, reject) => {
                const url = `/customerCancel/` + payload._id
                axios({ url: url, method: 'POST' })
                    .then(r => {
                        resolve(r.data)
                    })
                    .catch(e => {
                        reject(e)
                    })
            })
        },

        iAmHere({ context }, payload) {
            console.log(context)
            return new Promise((resolve, reject) => {
                const url = `/iAmHere/` + payload._id
                axios({ url: url, method: 'POST' })
                    .then(r => {
                        resolve(r.data)
                    })
                    .catch(e => {
                        reject(e)
                    })
            })
        },

        lsOSinOrdering() {
            localStorage.setItem(ORDER_STATE, OS_ORDERING)
            localStorage.setItem(ORDER_STATE_UPDATE_TIME, moment().format())
        },

        lsOSinCheckout() {
            localStorage.setItem(ORDER_STATE, OS_CHECKOUT)
            localStorage.setItem(ORDER_STATE_UPDATE_TIME, moment().format())
        },

        setTipAmount({ commit }, amount) {
            commit('SET_TIP', amount)
        },

        customerLog({ state, getters }, message) {
            if (!state.customerLogging) {
                return
            }
            let payload = {}
            payload["sessionId"] = state.sessionId
            payload["customerId"] = state.customerId
            payload["locationId"] = state.locationId
            payload["customerPhone"] = getters.getUserInfo.phone
            payload["message"] = message
            return new Promise((resolve, reject) => {
                const url = `/customerLog`
                axios({ url: url, data: payload, method: 'POST' })
                    .then(r => { resolve(r.data) })
                    .catch(e => { reject(e) })
            })
        }
    },
    modules: { // setting and updating the state        
    }
});
